// extracted by mini-css-extract-plugin
export var attachment = "_pq-a";
export var emailContainer = "_pq-4";
export var emailContentPaddedContainer = "_pq-b";
export var emailHeader = "_pq-6";
export var emailIframe = "_pq-3";
export var emailInfoIcon = "_pq-9";
export var emailShortenedSummary = "_pq-e";
export var infoDropdown = "_pq-0";
export var infoRowBoundedContent = "_pq-d";
export var internal = "_pq-5";
export var merchant = "_pq-8";
export var messageInputContainer = "_pq-h";
export var normal = "_pq-7";
export var replyCard = "_pq-f";
export var subtleButton = "_pq-1";
export var subtleButtonIconContainer = "_pq-2";
export var toggleViewRepliesButton = "_pq-c";
export var wrappingText = "_pq-g";